import { IHttpApi, Response, MachineStatus, SubCenter, Order, HistoricAlarm } from '.';

export class HttpClient implements IHttpApi {

  protected constructor(private readonly url: string) { }

  private async fetch(path: string, method: string, body?: object): Promise<Response> {
    const res = await fetch(this.url + path, {
      method: method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })

    if (res.status === 500) {
      throw new Error('Internal server error');
    }

    if (!res.ok) {
      throw new Error('Failed to fetch');
    }

    return res.json();
  }

  private async get(path: string) {
    const response = await this.fetch(path, 'GET');
    if (response.code !== 0) {
      throw new Error(response.message);
    }
    return response.payload;
  }

  private async post(path: string, body: object) {
    const response = await this.fetch(path, 'POST', body);
    if (response.code !== 0) {
      throw new Error(response.message);
    }
  }

  async read_current_user() {
    // TODO: missing
    return {
      id: '1',
      name: 'Massimiliano D.',
      started_at: Date.now() - 1000 * 60 * 9,
      role: 'supervisor',
      is_admin: true,
    }
  }

  async current_machine_status() {
    const machines = await this.get('/machines/status') as MachineStatus[];
    if (!machines || machines.length === 0) {
      throw new Error('No machines found');
    }
    if (machines.length > 1) {
      throw new Error('Multiple machines found');
    }
    return machines[0];
  }

  async list_orders() {
    return await this.get('/machines/workings/operations') as Order[];
  }

  async list_alarms() {
    return await this.get('/machines/alarms/history') as HistoricAlarm[];
  }

  async update_subcenters(subcenters: SubCenter[]) {
    await this.post('/machines/subcenters/update', subcenters);
  }

  static setup(url: string) {
    return new HttpClient(url);
  }

}
